package one.devsbox.www.ui.cmd

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import one.devsbox.www.provider.LocalMeProvider
import one.devsbox.www.provider.MeProvider
import one.devsbox.www.tools.ArgsId
import tk.mallumo.compose.navigation.LocalNavigation
import tk.mallumo.compose.navigation.LocalNavigationArgs
import tk.mallumo.compose.navigation.Navigation
import tk.mallumo.compose.navigation.args
import tk.mallumo.compose.navigation.viewmodel.viewModel

class CmdCtx private constructor(
    val vm: CmdVM,
    val nav: Navigation,
    val me: MeProvider,
    val args: ArgsId
) {
    val action get() = vm.action

    companion object {
        @Composable
        fun get(): CmdCtx {
            val nav = LocalNavigation.current
            val vm = nav.viewModel(CmdVM::class)
            val me = LocalMeProvider.current
            val args = LocalNavigationArgs.current.args<ArgsId>()

            return remember {
                CmdCtx(vm, nav, me, args).apply {
                    vm.setup(this)
                }
            }
        }
    }
}
